var module = angular.module('octopusApp.infrastructure');

module.factory('octoDropdownMenu', function($compile) {
  return {
    show: function(scope, relativeToElement, templateId, data, position) {
      var dropdownElement = null;
      scope.$on('$destroy', function () {
        if (dropdownElement) {
          dropdownElement.remove();
        }
      });

      var containerPos = $("#main-wrapper").offset();

      var element = relativeToElement;
      if (!position) {
        var refPos = element.offset();
        var refHeight = element.outerHeight();

        position = { x: refPos.left, y: refPos.top + refHeight };
      }

      position.y = position.y - containerPos.top;

      var childScope = scope.$new();
      var template = $("#" + templateId);

      var text = [];
      text.push("<div class='dropdown'>");
      text.push(" <a class='hidden' id='_externaldropdown_toggler' data-toggle='dropdown'></a>");
      text.push(template.html());
      text.push("</div>");

      var html = $compile(text.join(""))(childScope);

      _.each(data, function (val, key) {
        childScope[key] = val;
      });
      childScope.$digest();


      dropdownElement = html;

      html.css({
        "position": "absolute",
        "z-index": "100000",
        "left": (position.x) + "px",
        "top": (position.y) + "px"
      });

      var parent = $("#dynamicallyGeneratedContent");
      parent.empty();
      parent.append(html);

      var toggler = $("a#_externaldropdown_toggler", html).first();
      toggler.dropdown("toggle");
    }
  };
});

module.factory('octoDialog', function ($uibModal) {
  return {
    asyncConfirm: function (options) {
      options = options || {};

      if (!options.windowClass) {
        options.windowClass = "modal-alert modal-warning fade";
      }

      $uibModal.open({
        templateUrl: 'infrastructure/controllers/views/async-confirm-dialog.html',
        controller: 'AsyncConfirmDialogController',
        windowClass: options.windowClass,
        resolve: {
          options: function() { return options; }
        }
      });
    },

    alertMessageBox: function (options) {
      options = options || {};

      if (!options.windowClass) {
        options.windowClass = "modal-alert modal-warning fade";
      }

      return $uibModal.open({
        templateUrl: 'infrastructure/controllers/views/alert-dialog.html',
        controller: 'AlertDialogController',
        windowClass: options.windowClass,
        resolve: {
          options: function () { return options; }
        }
      }).result;
    },

    messageBox: function(caption, message, buttons) {
      return $uibModal.open({
        templateUrl: 'infrastructure/controllers/views/message-box-dialog.html',
        controller: 'MessageBoxController',
        resolve: {
          options: function() {
            return {
              caption: caption, message: message, buttons: buttons
            };
          }
        }
      }).result;
    },

    sort: function (options) {
      $uibModal.open({
        templateUrl: 'infrastructure/controllers/views/sort-dialog.html',
        controller: 'SortDialogController',

        resolve: {
          options: function() { return options; }
        }
      });
    },

    prompt: function(options) {
      return $uibModal.open({
        templateUrl: 'infrastructure/controllers/views/prompt-dialog.html',
        controller: 'PromptDialogController',
        windowClass: "modal-alert modal-info fade",
        resolve: {
          options: function() { return options; }
        }
      }).result;
    },

    confirmDelete: function(what, onContinue) {
      var options = {
        title: "Delete " + what,
        message: "Deleting this " + what + " is permanent, there is no going back. Do you wish to continue?",
        executeButtonClass: "btn-warning",
        executeButtonText: "Delete " + what,
        execute: function (dialog) {
          dialog.busy.promise(onContinue().then(function() {
            dialog.dismiss();
          }));
        }
      };

      return $uibModal.open({
        templateUrl: 'infrastructure/controllers/views/async-confirm-dialog.html',
        controller: 'AsyncConfirmDialogController',
        windowClass: "modal-alert modal-warning fade",
        resolve: {
          options: function() { return options; }
        }
      }).result;
    },

    confirmChangesWillBeLost: function(onContinue) {
      var w = 'If you leave this page, any changes you have made will be lost. Are you sure you wish to leave this page?';

      var options = {
        title: "Unsaved changes",
        message: w,
        executeButtonClass: "btn-warning",
        executeButtonText: "Discard changes",
        execute: function (dialog) {
          onContinue();
          dialog.dismiss();
        }
      };

      return $uibModal.open({
        templateUrl: 'infrastructure/controllers/views/async-confirm-dialog.html',
        windowClass: "modal-alert modal-warning fade",
        controller: 'AsyncConfirmDialogController',

        resolve: {
          options: function() { return options; }
        }
      }).result;
    }
  };
});





//////////////////
// WEBPACK FOOTER
// ./app/infrastructure/services/octo_dialog.js
// module id = 2087961845900806
// module chunks = 1